/**
 * Static dummy TipTap document rendered for every preview section.
 *
 * Preview is a structural rehearsal — it never reflects the section's real
 * `content` field. Keeping the doc shared (and `as const`) means every
 * preview section renders the exact same lorem ipsum, signalling to the
 * admin that the prose is illustrative chrome, not data.
 */
export const DUMMY_SECTION_DOC = {
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      content: [
        {
          type: 'text',
          // eslint-disable-next-line i18next/no-literal-string -- lorem-ipsum filler; the panel renders a translated notice saying so
          text: 'Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi. Proin porttitor, orci nec nonummy molestie, enim est eleifend mi, non fermentum diam nisl sit amet erat. Duis semper.',
        },
      ],
    },
  ],
} as const;
